export const VersionAlert = ({messageFromParent}) => {           
    return (
        <>
            { messageFromParent !== null  && messageFromParent.ShowMessage === true ? (                
                    <p style={{color: "red"}}>{messageFromParent.MessageAlert}</p>                
            ) : null }
        </>
    )
}